import { atom } from "jotai";
import { isPublicAtom } from "../permissions";
import { isTemplatePageAtom } from "../templates";
import { togglesAtom } from "../diagramming";
import { isViewerAtom } from "../canvas";
import { isDraftModeExcludingTemplatesAtom } from "../nodes";

/**
 * Derived atom that determines whether the copilot should be shown in the BuilderNav and SidebarDrawer
 *
 * The copilot is shown when:
 * - NOT a public canvas
 * - NOT a template page
 * - NOT a user with can_view access only (isViewer)
 * - AND either AI copilot cobuild is enabled (build mode) OR we're in draft mode (excluding templates)
 */
export const isCopilotEnabledAtom = atom((get) => {
  const isPublic = get(isPublicAtom);
  const isTemplatePage = get(isTemplatePageAtom);
  const isViewer = get(isViewerAtom);
  const toggles = get(togglesAtom);
  const isDraftModeNotTemplates = get(isDraftModeExcludingTemplatesAtom);

  return (
    !isPublic &&
    !isTemplatePage &&
    !isViewer &&
    (toggles.aiCopilotCobuild || isDraftModeNotTemplates)
  );
});

isCopilotEnabledAtom.debugLabel = "isCopilotEnabledAtom";
